export const STUDIO = "Oge Eyesthetic Nail Studio";

export const CATS = [
  { id: "wedding",     label: "Wedding",          icon: "💍", desc: "Timeless bridal elegance" },
  { id: "date_night",  label: "Date Night",       icon: "🌹", desc: "Sultry & sophisticated" },
  { id: "party",       label: "Party",            icon: "🎉", desc: "Bold & celebratory" },
  { id: "fashion",     label: "Fashion Forward",  icon: "✨", desc: "Runway-inspired edge" },
  { id: "young",       label: "Young & Playful",  icon: "🌈", desc: "Fun, bright & expressive" },
  { id: "mature",      label: "Refined Classic",  icon: "🕊️", desc: "Understated & polished" },
  { id: "clean",       label: "Clean Girl",       icon: "🤍", desc: "Minimalist & modern" },
  { id: "artistic",    label: "Artistic",         icon: "🎨", desc: "Abstract & creative" },
  { id: "seasonal",    label: "Seasonal",         icon: "🍂", desc: "Trending now" },
  { id: "brunch",      label: "Brunch Vibes",     icon: "🥂", desc: "Chic & effortless" },
];

export const PRODUCTS = {
  "Gel & Builder": [
    "Gel polish", "Hard gel", "Builder gel", "Rubber base gel", "Polygel", "Gel nail tips",
  ],
  "Acrylic": [
    "Acrylic powder (pink)", "Acrylic powder (white)", "Monomer liquid", "Acrylic nail tips", "Dip powder",
  ],
  "Nail Art": [
    "Line art gel", "Chrome powder", "Pigment powder", "Glitter gel", "Holographic flakes", "Foil transfer",
  ],
  "Embellishments": [
    "Rhinestones", "3D nail charms", "Caviar beads", "Gold leaf", "Dried flowers", "Press-on gems",
  ],
  "Base & Finish": [
    "Base coat", "Primer", "UV/LED top coat", "Matte top coat", "No-wipe top coat", "Nail dehydrator",
  ],
  "Tools": [
    "Nail drill", "Cuticle oil", "Cuticle pusher", "Buffer block", "Nail forms", "Nail repair fiberglass",
  ],
};

export const STEPS = ["You", "Occasion", "Photo", "Designs", "Done"];
